import { BorderLeft } from "@mui/icons-material";
import color from "../../../../../../constants/color";

export const styles = {
    whiteSection: {
        backgroundColor: color.card,
        m: 2,
        borderRadius: "20px",
    },
    csvBtns: {
        "& svg": {
            mr: 1,
        },
        borderBottomLeftRadius: 50,
        borderTopLeftRadius: 50,
        px: 2,
        backgroundColor: color.card,
        color: color.text,
        textTransform: "none",
        fontSize: "12px",
        fontWeight: "500",
        boxShadow: "none",
        "&:hover": {
            color: 'white !important',
        }
    },
    checkinBtns: {
        "& svg": {
            mr: 1,
        },
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        px: 2,
        backgroundColor: "#28AA4A",
        color: "white !important",
        textTransform: "none",
        fontSize: "12px",
        fontWeight: "500",
        boxShadow: "none",
        "&:hover": {
            color: 'white !important',
        }
    },
    checkinRefundBtns: {
        "& svg": {
            mr: 1,
        },
        borderLeft: '1px solid #fff',
        borderBottomRightRadius: 50,
        borderTopRightRadius: 50,
        backgroundColor: "#28AA4A",
        color: "#fff",
        textTransform: "none",
        fontSize: "12px",
        fontWeight: "500",
        boxShadow: "none",

    },
    dropdownMenu: {
        '& .MuiPaper-root': {
            width: 142,
            borderRadius: '14px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E5E5',
            boxShadow: 'none', // remove default MUI elevation
        },
        "& .MuiMenuItem-root": {
            fontSize: "14px",
            padding: "8px 16px",
            "&:hover": {
                backgroundColor: "#00ABF4",
                color: "#FFFFFF", // change text color on hover
            }
        }
    },
    paymentSection: {
        backgroundColor: color.card,
        m: 2,
        marginBottom: '-20px',
        borderRadius: "15px",
        p: 3
    },
    paymentTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1
    },
    dropDownButton: {
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer"
    },
    paymentHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
    },
    paymentTitle: {
        height: '24px',
        opacity: 1,
        fontWeight: 600,
        fontSize: '16px',
        color: '#202020',
    },
    paymentCount: {
        width: '26px',
        height: '26px',
        opacity: 1,
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontSize: '16px',
        fontStyle: 'normal', // 'SemiBold' is not valid; use weight
        lineHeight: '100%',
        letterSpacing: 0,
        backgroundColor: '#00ABF417',
        color: '#00ABF4', // assumed for contrast
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tableHeader: {
        opacity: 1,
        color: '#878787',
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '14px',
        textAlign: 'left',
        padding: '8px 12px',
    },
    tableCell: {
        fontWeight: 400,
        textAlign: 'left',
        fontSize: '14px',
        color: 'black',
        padding: '8px 12px',
        borderBottom: "none !important",
    },
    tableCellButton: {
        fontWeight: 400,
        textAlign: 'left',
        fontSize: '14px',
        color: 'black',
        padding: '8px 0px',
        borderBottom: "none !important",
    },
    actionButton: {
        minWidth: "32px",
        width: "32px",
        height: "32px",
        p: 0,
        borderRadius: "50%"
    },
    actionMenu: {
        backgroundColor: "#fff",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
        borderRadius: "8px",
        mt: 1
    },
}